import { useEffect } from "react";
import { graphql, useStaticQuery } from "gatsby";

const insertEkyScript = (ean, sku, language) => {
  if ((sku || ean) && !document.querySelector(".eky-script-tag")) {
    var script = document.createElement("script");
    document.head.appendChild(script);
    script.classList.add("eky-script-tag");
    script.type = "text/javascript";
    script.async = true;
    script.dataset.ekyDistributor = "e8d4b8ca-7e91-43e3-b1d7-e439164be549";
    script.dataset.ekyLanguage = language;
    script.dataset.ekyEan = ean;
    script.dataset.ekySku = sku;
    script.src = "//media.pointandplace.com/js/pointandplace.js";
  }
};

const eventuallyInsertEkyScript = async (eanCode, productId, language) => {
  insertEkyScript(eanCode, productId, language);
};

const eventuallyRemoveEkyScript = () => {
  const ekyScript = document.querySelectorAll(
    '[distributor="e8d4b8ca-7e91-43e3-b1d7-e439164be549"],[data-eky-distributor="e8d4b8ca-7e91-43e3-b1d7-e439164be549"]'
  );
  const ekuBus = document.querySelector("eyekandy-event-bus");

  const allScripts = [...ekyScript].concat(ekuBus).filter(Boolean);

  if (allScripts.length) {
    allScripts.forEach((element) => {
      element.remove();
    });
  }
};

const useEkyScript = (eanCode, productId) => {
  const { config } = useStaticQuery(graphql`
    {
      config: liferayGeneralConfiguration {
        virtualRealityActiveFieldSet {
          virtualRealityActive
          virtualRealityDistributorLangFieldSet {
            virtualRealityDistributorLang
            virtualRealityDistributorCode
          }
        }
      }
    }
  `);
  const checkVirtualRealityActive =
    config.virtualRealityActiveFieldSet &&
    !!config.virtualRealityActiveFieldSet.virtualRealityActive?.length;
  const language =
    config.virtualRealityActiveFieldSet?.virtualRealityDistributorLangFieldSet?.[0]
      ?.virtualRealityDistributorLang;

  useEffect(() => {
    if (checkVirtualRealityActive) {
      eventuallyInsertEkyScript(eanCode, productId, language);
      return () => eventuallyRemoveEkyScript();
    }
  }, [eanCode, productId, checkVirtualRealityActive, language]);
};

export default useEkyScript;
